/**
 * Class names, assembled. Internal to anubis — an app never writes a class name (anubislint A006),
 * so this is the one place a component turns its semantic props into the stylesheet's vocabulary.
 */
export function cx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}

/** `a-stack--gap-md` from (`a-stack`, `gap`, `md`); nothing when the value is absent. */
export function mod(block: string, name: string, value: string | number | undefined): string {
  return value === undefined ? '' : `${block}--${name}-${value}`;
}
